import List from "./List";
export * from "./type";
export { generateListData, getDisabledListItems } from "./List";
export default List;
